// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__11DAa","title":"BackImages_title__1F3IK","images":"BackImages_images__2eqD-"};